import { useState } from 'react';

import { useAppDispatch, useAppSelector } from 'hooks';

import {
  selectLoading,
  selectConversationId,
  selectIntentId,
  selectIntentIdToLoad,
  selectIsAutonomousAgentWorkflowPreview,
  addScreenReaderNotification,
  selectFreeFormInputPlaceholder,
} from 'reducers/workflows';
import {
  autonomousAgentQuery,
  initAutonomousAgentConversation,
} from 'actions/workflows/v3';
import IntentFormWrapper from 'components/FormWrapper/IntentFormWrapper';
import { TextInput } from 'components/TextInput/TextInput';

let conversationStarted = false;

const AutonomousAgentInput = () => {
  const dispatch = useAppDispatch();
  const conversationId = useAppSelector(selectConversationId);
  const placeholder = useAppSelector(selectFreeFormInputPlaceholder);
  const intentId = useAppSelector(selectIntentIdToLoad);
  const returnedIntentId = useAppSelector(selectIntentId);
  const isWorkflowPreview = useAppSelector(
    selectIsAutonomousAgentWorkflowPreview,
  );
  const loading = useAppSelector(selectLoading);

  const [query, setQuery] = useState('');

  const isQueryEmpty = query.trim() === '';
  const isSubmitDisabled = isQueryEmpty || loading;

  const onSubmit = () => {
    dispatch(addScreenReaderNotification('Message sent'));

    if (conversationStarted) {
      dispatch(
        autonomousAgentQuery({
          conversationId,
          data: {
            intent_id: returnedIntentId || intentId || '',
            is_workflow_preview: isWorkflowPreview,
            query,
          },
        }),
      );
    } else {
      dispatch(
        initAutonomousAgentConversation({
          conversation_id: conversationId,
          free_form_query: query,
          intent_id: typeof intentId === 'string' ? intentId : null,
        }),
      );
      conversationStarted = true;
    }

    setQuery('');
  };

  return (
    <IntentFormWrapper
      formTitle=''
      isDisabled={isSubmitDisabled}
      isForm
      isLastStep={false}
      noValidate
      onSubmit={onSubmit}
      stepIndex={-1}
    >
      <TextInput
        aria-label={placeholder}
        dir='auto'
        disableSendMessage={isSubmitDisabled}
        InputProps={{
          inputProps: {
            className: 'forethought-scrollbar',
            'data-testid': 'autonomous-agent-input',
          },
        }}
        maxRows={10}
        multiline
        onChange={e => {
          setQuery(e.target.value);
        }}
        onSendMessage={onSubmit}
        placeholder={placeholder}
        value={query}
      />
    </IntentFormWrapper>
  );
};

export default AutonomousAgentInput;
